@defer (on timer(250ms)) {
<div class="row row-medium">
    <div class="col-12 col-md-6 d-flex align-items-stretch">
        <app-day-of-week-chart class="d-flex align-self-stretch flex-grow-1"></app-day-of-week-chart>
    </div>
    <div class="col-12 col-md-6 d-flex align-items-stretch">
        <div class="card flex-grow-1">
            <div class="card-header">
                <h4 class="card-header-title">
                    <span class="energy-label-header-icon notranslate me-2" aria-hidden="true">A</span>
                    Energy label
                </h4>
            </div>
            <div class="card-body">
                <app-location-energy-label-info [location]="locationEntity?.location"></app-location-energy-label-info>
            </div>
        </div>
    </div>
</div>
} @placeholder {
    <div class="row row-medium deferred-dashboard-row">
        <ngx-skeleton-loader class="col-12"></ngx-skeleton-loader>
    </div>
}

@defer (on timer(750ms)) {
<ng-template #customCorrectionModalBody>
    <p>Select the meter whose historical data should be corrected.</p>
    <app-form-field label="Meter">
        <select class="form-select" required [(ngModel)]="selectedCorrectionMeterId">
            <option *ngFor="let option of correctionOptions" [ngValue]="option.meterId">
                {{correctionOptionLabel(option)}}
            </option>
        </select>
    </app-form-field>
    <dl *ngIf="selectedCorrectionOption as option" class="row correction-period mt-3 mb-0">
        <dt class="col-3">From</dt>
        <dd class="col-9 notranslate">{{formatCorrectionTimestamp(option.startTimestamp)}}</dd>
        <dt class="col-3">Until</dt>
        <dd class="col-9 notranslate">{{formatCorrectionTimestamp(option.stopTimestamp)}}</dd>
    </dl>
    <p class="mt-3 mb-0">The source data for this period will be retrieved again and existing measurements may be updated.</p>
</ng-template>

<div class="row row-medium location-overview-row">
    <div class="col-12 col-md-6 d-flex align-items-stretch">
        <div class="card flex-grow-1 location-overview-card">
            <div class="card-header d-flex align-items-center justify-content-between gap-2">
                <h4 class="card-header-title">
                    <i class="bi bi-speedometer2 meters-header-icon me-2" aria-hidden="true"></i>
                    Meters
                </h4>
                <div class="d-flex align-items-center gap-2">
                    <button type="button" class="btn" role="button" aria-label="Enlarge meters"
                            (click)="locationMeters.openModal()">
                        <i class="bi bi-arrows-angle-expand"></i>
                    </button>
                    <button *ngIf="appContext.isAdminOrIntermediary()" type="button"
                            class="btn btn-sm btn-outline-secondary correct-meter-data-button"
                            [disabled]="correctionPending || correctionOptions.length === 0"
                            [title]="correctionOptions.length ? 'Correct meter data' : 'No meters available for correction'"
                            (click)="openCustomCorrectionModal(customCorrectionModalBody)">
                        <i class="bi bi-arrow-repeat" aria-hidden="true"></i>
                        <span>Correct meter data</span>
                    </button>
                </div>
            </div>
            <div class="card-body meters-card-body">
                <app-location-meters #locationMeters [location]="locationEntity"></app-location-meters>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-6 d-flex align-items-stretch">
        <div *ngIf="energyCompass.expanded" class="compass-backdrop" (click)="energyCompass.expanded=false"></div>
          <div class="card flex-grow-1 location-overview-card compass-card" [class.compass-expanded]="energyCompass.expanded" [class.compass-crrem]="energyCompass.mode === 'crrem'">
            <div class="card-header dropdown">
                <h4 class="card-header-title">
                    <img src="assets/images/icons/environmentalism.png" width="20px" class="me-2">
                    Energy compass
                </h4>
                <div class="btn-group btn-group-sm ms-auto me-2" role="group" aria-label="Energy compass view">
                    <button type="button" class="btn" [class.btn-primary]="energyCompass.mode === 'weii'"
                        [attr.aria-pressed]="energyCompass.mode === 'weii'" (click)="energyCompass.mode = 'weii'">WEii</button>
                    <button type="button" class="btn" [class.btn-primary]="energyCompass.mode === 'crrem'"
                        [attr.aria-pressed]="energyCompass.mode === 'crrem'" (click)="energyCompass.mode = 'crrem'">CRREM</button>
                </div>
                <button *ngIf="!energyCompass.expanded" type="button" class="btn compass-expand-button notranslate" [attr.aria-label]="energyCompass.displayText(energyCompass.expanded ? 'shrink energy compass' : 'enlarge energy compass')" [attr.aria-expanded]="energyCompass.expanded" (click)="energyCompass.expanded=!energyCompass.expanded">
                      <i class="bi" [class.bi-arrows-angle-expand]="!energyCompass.expanded" [class.bi-arrows-angle-contract]="energyCompass.expanded"></i>
                  </button>
                  <button type="button" class="btn" data-bs-toggle="dropdown" data-bs-auto-close="outside"
                        aria-expanded="false" [attr.aria-label]="energyCompass.mode === 'weii' ? 'WEii-berekeningsinstellingen' : energyCompass.displayText('crrem display options')">
                    <i class="bi bi-three-dots-vertical"></i>
                </button>
                <app-widget-options-menu title="Display settings" [alignEnd]="true">
                    <app-weii-calculation-options *ngIf="energyCompass.mode === 'weii'"
                            [availability]="energyCompass.calculationOptionAvailability"
                            [isFullElectric]="locationEntity?.location?.info?.allElectric === true"
                            [showTitle]="false"
                            inputIdPrefix="location-energy-compass">
                    </app-weii-calculation-options>


                    <ng-container *ngIf="energyCompass.mode === 'crrem'">
                      <div class="dropdown-item"><label class="form-check"><input type="checkbox" class="form-check-input" [(ngModel)]="energyCompass.crremDisplay.projection"><span class="form-check-label">Show projection</span></label></div>
                      <div class="dropdown-item"><label class="form-check"><input type="checkbox" class="form-check-input" [(ngModel)]="energyCompass.crremDisplay.crossing"><span class="form-check-label">Mark exceedance year</span></label></div>
                      <div class="dropdown-item"><label class="form-check"><input type="checkbox" class="form-check-input" [(ngModel)]="energyCompass.crremDisplay.target"><span class="form-check-label">Show CRREM target pathway</span></label></div>
                    </ng-container>
                  </app-widget-options-menu>
                <button *ngIf="energyCompass.expanded" type="button" class="btn-close compass-close-button notranslate"
                        [attr.aria-label]="energyCompass.displayText('close')"
                        (click)="energyCompass.expanded=false"></button>
            </div>
            <div class="card-body d-flex flex-grow-1 position-relative weii-card-body">
                <app-location-energy-compass #energyCompass [location]="locationEntity?.location"
                                             class="d-flex flex-grow-1 w-100"></app-location-energy-compass>
            </div>
        </div>
    </div>
</div>
} @placeholder {
    <div class="row row-medium deferred-dashboard-row">
        <ngx-skeleton-loader class="col-12"></ngx-skeleton-loader>
    </div>
}

@defer (on viewport) {
    <div *ngIf="hasMeterTree" class="row row-medium energy-flow-row" [class.d-none]="meterTreeDataAvailable === false">
        <div class="col-12 col-md-8 d-flex align-items-stretch">
            <app-meter-tree-view [selectedLocation]="locationEntity" (meterTreeDataAvailable)="onMeterTreeDataAvailable($event)"
                                 (measurementsReceived)="meterTreeMeasurements = $event"
                                 class="d-flex flex-column flex-fill h-100 w-100 overflow-hidden"></app-meter-tree-view>
        </div>
        <div class="col-12 col-md-4 d-flex align-items-stretch">
            <app-meter-performance-chart [selectedLocation]="locationEntity" [meterTreeMeasurements]="meterTreeMeasurements" class="d-flex align-self-stretch flex-grow-1 w-100 overflow-hidden"></app-meter-performance-chart>
        </div>
    </div>
} @placeholder {
    <div class="row row-medium energy-flow-row deferred-dashboard-row" [class.d-none]="!hasMeterTree">
        <ngx-skeleton-loader class="col-12"></ngx-skeleton-loader>
    </div>
}

<div class="row row-medium">
    <div class="col-12 col-md-8 d-flex align-items-stretch">
        <app-electricity-chart class="d-flex align-self-stretch flex-grow-1 h-100 w-100"></app-electricity-chart>
    </div>
    <div class="col-12 col-md-4 d-flex align-items-stretch">
        <app-costs-chart class="card d-flex align-self-stretch flex-grow-1 w-100"></app-costs-chart>
    </div>
</div>

@defer (on viewport) {
    <div class="row row-medium">
        <div class="col-12 col-md-8 d-flex align-items-stretch">
            <app-gas-chart class="d-flex align-self-stretch flex-grow-1 h-100 w-100"></app-gas-chart>
        </div>
        <div class="col-12 col-md-4 d-flex align-items-stretch">
            <app-energy-profile-scatter-chart class="d-flex align-self-stretch flex-grow-1 h-100 w-100"
                                              [location]="locationEntity?.location"></app-energy-profile-scatter-chart>
        </div>
    </div>
} @placeholder {
    <div class="row row-medium deferred-dashboard-row">
        <ngx-skeleton-loader class="col-12"></ngx-skeleton-loader>
    </div>
}

@defer (on viewport) {
    <div class="row row-medium">
        <div class="col-12 col-md-8 d-flex align-items-stretch">
            <app-water-chart class="d-flex align-self-stretch flex-grow-1 h-100 w-100"></app-water-chart>
        </div>
        <div class="col-12 col-md-4 d-flex align-items-stretch">
            <app-co2-chart class="card d-flex align-self-stretch flex-grow-1 w-100"></app-co2-chart>
        </div>
    </div>
} @placeholder {
    <div class="row row-medium deferred-dashboard-row">
        <ngx-skeleton-loader class="col-12"></ngx-skeleton-loader>
    </div>
}
